<template>
  <div>
    <pt-sub-title title="同步获取订单" :class="$style['tip-text-title-content']">
      <el-button type="text" icon="el-icon-refresh" @click="synchronization"
                 :loading="synchroLoading">同步</el-button>
    </pt-sub-title>
    <el-alert title="同步获取订单信息提示" type="warning"
              description="此列表显示该用户在运营平台/cps系统的已绑定合同/订单，如果此处订单与生命银行订单不一致，可手动触发订单同步。若此列表未获取到订单请与运营管理员联系。"
              show-icon>
    </el-alert>
    <div :class="$style.cpsId" v-if="cpsSystem">
      <p>客户CPS系统ID：{{cpsSystem}}</p>
    </div>
    <wt-paged-table v-loading="loading" :on-request-data="getTableData" :total-size="totalNumber"
                    :page-size="pageSize" ref="table">
      <el-table @expand-change="expandReport" :data="tableData">
        <el-table-column type="expand" fixed="left">
          <template slot-scope="props">
            <div v-loading="rowShow">
              <table v-for="(item,index) in props.row.reportList" :key="index"
                     :class="$style['basic-report-table']">
                <tr>
                  <td>产品名称：</td>
                  <td>{{item.productName}}&nbsp;&nbsp;&nbsp;{{item.proBarcode}}</td>
                </tr>
                <tr>
                  <td>CPS订单状态：</td>
                  <td>{{item.cpsOrderStatus}}</td>
                </tr>
                <tr>
                  <td>基本情况报告：</td>
                  <td>{{item.basicReport}}</td>
                </tr>
                <tr>
                  <td>(生产进度)报告已生成：</td>
                  <td>{{item.reportGenerated}}</td>
                </tr>
                <tr>
                  <td>(生产进度)质量评价：</td>
                  <td>{{item.qualityEvaluation}}</td>
                </tr>
                <tr>
                  <td>年监报告：</td>
                  <td>
                    <div v-if="item.annualReport.length" :class="$style['specification-table-div']"
                         class="page-background">
                      <table :class="$style['specification-table']">
                        <th>
                        <td>报告日期</td>
                        <td>报告人</td>
                        <td>审核人</td>
                        <td>脐血库</td>
                        <td>存储年份</td>
                        </th>
                        <tr v-for="(sItem,sIndex) in item.annualReport" :key="sIndex">
                          <td>{{sItem.checkDate}}</td>
                          <td>{{sItem.reportUser}}</td>
                          <td>{{sItem.checkUser}}</td>
                          <td>{{sItem.orgHouseName}}</td>
                          <td>{{sItem.storageYear}}年</td>
                        </tr>
                      </table>
                    </div>
                    <div v-else :class="$style['noData']">
                      暂无数据
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            <div v-if="props.row.reportList.length === 0" :class="$style['noData']">
              暂无数据
            </div>
          </template>
        </el-table-column>
        <template>
          <el-table-column label="母亲姓名">
            <template slot-scope="scope">
              {{scope.row.motherName}}
            </template>
          </el-table-column>
          <el-table-column label="合同号" min-width="123">
            <template slot-scope="scope">
              {{scope.row.contractCode}}
            </template>
          </el-table-column>
          <el-table-column label="母亲手机号" min-width="110">
            <template slot-scope="scope">
              {{scope.row.motherMobile}}
            </template>
          </el-table-column>
          <el-table-column label="母亲身份证" min-width="150">
            <template slot-scope="scope">
              {{scope.row.motherCardId}}
            </template>
          </el-table-column>
          <el-table-column label="组织名称" min-width="150">
            <template slot-scope="scope">
              {{scope.row.orgName}}
            </template>
          </el-table-column>
          <el-table-column label="结算公司" min-width="150">
            <template slot-scope="scope">
              {{scope.row.balanceOrg}}
            </template>
          </el-table-column>
          <el-table-column label="条码" min-width="130">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.products" :key="index">
                <span v-if="item.proBarcode">{{item.proBarcode}}</span>
                <span v-else :class="$style['tip-text']">缺少条码</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              {{scope.row.createTime}}
            </template>
          </el-table-column>
          <el-table-column label="采集时间">
            <template slot-scope="scope">
              {{scope.row.registerTime}}
            </template>
          </el-table-column>
          <el-table-column label="产品代码">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.products" :key="index">
                {{item.productCode}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="产品名称" min-width="135">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.products" :key="index">
                {{item.productName}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="是否续存">
            <template slot-scope="scope">
              {{ scope.row.renewFlg==='Y'?"是":"否" }}
            </template>
          </el-table-column>
          <el-table-column label="绑定人证件号">
            <template slot-scope="scope">
              {{ scope.row.customerBindCard }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="okUnbindCps(scope.row)">解绑</el-button>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </wt-paged-table>
    <el-alert title="脐荐康第三轮奖励发放条件" type="warning"
              description="协和的条码号（前缀：'TJ','PSCS','ZJ','MSC','90075'）必须满足已达成进度 '报告已生成'; 其他条码号，必须满足进度 '质量评价' 的 code 为 'Y'"
              show-icon>
    </el-alert>
  </div>
</template>
<script>
import { cpsOrederStatus } from './customer-detail-option'
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    userLogin: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      totalNumber: 0,
      tableData: [],
      rowShow: false,
      page: 0,
      loading: false,
      cpsSystem: '',
      cpsOrederStatus: cpsOrederStatus,
      // 是否可点击同步
      synchroLoading: false
    }
  },
  methods: {
    getTableData (page, next) {
      this.loading = true
      this.page = page
      let data = {
        userLogin: this.userLogin,
        pageableParam: {
          page: page,
          size: 10
        }
      }
      this.$store.dispatch('getUserContracts', data).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        this.loading = false
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err || '获取订单失败')
        this.loading = false
      })
    },
    getCpsInfoByLogin () {
      this.loading = true
      this.$store.dispatch('getCpsInfoByLogin', this.userLogin).then(res => {
        this.cpsSystem = res.customerUserId
        this.loading = false
      }).catch(err => {
        this.$message.error(err || '获取订单失败')
        this.loading = false
      })
    },
    okUnbindCps (val) {
      this.$confirm('您确定解绑该身份证号嘛?', '解绑提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(res => {
        this.unbindCps(val)
      })
    },
    unbindCps (val) {
      this.loading = true
      let data = {
        userId: this.id,
        // identityCard: val.motherCardId
        identityCard: val.customerBindCard// 解绑时，更新对应的身份证号位绑定身份证号
      }
      this.$store.dispatch('unbindCps', data).then(res => {
        this.loading = false
        this.$message.success('解绑成功')
        this.getTableData(this.page)
      }).catch(err => {
        this.$message.error(err || '解绑身份证失败')
        this.loading = false
      })
    },
    synchronization () {
      // 同步之后，loading10秒，10秒之内不能点击
      this.synchroLoading = true
      setTimeout(_ => {
        this.synchroLoading = false
      }, 10000)
      this.$store.dispatch('getCPSSyn', this.userLogin).then(res => {
        this.$message.success('已触发CPS订单同步，请稍后刷新查看生命银行订单或样本')
      }).catch(err => {
        this.$message.error(err || '同步订单失败')
      })
    },
    expandReport (row, expanded) {
      if (expanded.length > 0 && !row.reportList) {
        row.reportList = []
        row.products.map((item, index) => {
          // if (item && item.proBarcode && /^01/.test(item.productCode)) {
          /* 打开01限制（必须是存储数据），兼容错误条码号 */
          if (item && item.proBarcode) {
            this.rowShow = true
            let tempData = {
              cardId: row.renewFlg === 'Y' ? row.buyerCardId : row.motherCardId, // 如果是续存合同，使用购买人的身份证
              proBarcode: item.proBarcode
            }
            let data = {
              renewFlg: row.renewFlg,
              proBarcode: item.proBarcode
            }
            this.$store.dispatch('getBasicReport', data).then(res => {
              let temp = { cpsOrderStatus: this.cpsOrederStatus[item.finalStatus] }
              temp.basicReport = res
              temp.productName = item.productName
              temp.proBarcode = item.proBarcode
              this.$store.dispatch('getCPSStorageProgress', item.proBarcode).then(res => {
                temp = { ...temp, ...res }
                this.getAnnualReport(tempData, temp, row)
              }).catch(err => {
                this.$message.error(err || '获取存储产品进度失败')
              })
            }).catch(err => {
              this.$message.error(err || '获取基础报告失败')
            })
          }
        })
      }
    },
    // 获取年度报告
    getAnnualReport (tempData, temp, row) {
      this.$store.dispatch('getAnnualReport', tempData).then(response => {
        this.rowShow = true
        temp.annualReport = response
        row.reportList.unshift(temp)
        this.rowShow = false
      }).catch(err => {
        this.$message.error(err || '获取年度报告失败')
      })
    }
  },
  created () {
    this.getCpsInfoByLogin()
  }

}
</script>
<style module lang="less">
.cpsId{
  color: #909399;
  padding: 0.1rem .2rem;
  p{
    font-weight: bold;
    font-size: 16px;
  }
}
.tip-text{
    color: red;
    font-size: 13px;
    text-align: end
}
.tip-text-title-content{
    :global
    .el-button{
        margin-left: 10px;
        padding: 0!important
    }
}
.basic-report-table{
  display: block;
  width: 100%;
  margin-top:10px;
  >tr{
    >td:nth-child(1){
      margin-left: 48px;
      display: flex;
      justify-content: flex-end;
      white-space: nowrap;
      width: auto;
    }
    >td:nth-child(2){
      min-width: 750px;
    }
  }
}
.specification-table-div{
    margin-bottom: 20px;
    padding: 10px 20px 30px;
}
.specification-table{
    display: table!important;
    width: 100%;
    background-color: #F9F9F9;
    th,tr{
        background-color: #F9F9F9;
        width: 100%!important;
        max-width: 100%!important;
        display: table-row!important;
        padding: 0!important;
        list-style-type:none;
        justify-content:center!important;
        border-bottom: 1px solid #C6C9D3;
        color: #5B5B5B!important;
    }
    td{
        color: #5B5B5B!important;
        text-align: center;
        justify-content:flex-start!important;
        padding: 10px!important;
    }
}
.noData{
  color:#909399;
  text-align: center;
}
</style>
